import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import AdminShell from "../../components/AdminShell";
import { api, formatApiError } from "../../lib/api";
import { Badge, Button, Card, Input, Label } from "../../components/ui-kit";

export default function AdminSettings() {
  const [settings, setSettings] = useState({});
  const [security, setSecurity] = useState(null);
  const [whatsapp, setWhatsapp] = useState(null);
  const load = () => {
    Promise.all([api.get("/admin/settings"), api.get("/admin/security/status"), api.get("/admin/whatsapp/templates")])
      .then(([s, sec, wa]) => {
        setSettings(s.data);
        setSecurity(sec.data);
        setWhatsapp(wa.data);
      })
      .catch((e) => toast.error(formatApiError(e)));
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const payload = {
        app_name: settings.app_name,
        support_email: settings.support_email,
        support_phone: settings.support_phone,
        platform_commission_rate: Number(settings.platform_commission_rate),
        driver_match_max_km: Number(settings.driver_match_max_km),
        service_radius_km: Number(settings.service_radius_km),
        promo_auto_ai_enabled: Boolean(settings.promo_auto_ai_enabled),
        require_email_verification: Boolean(settings.require_email_verification),
      };
      const { data } = await api.put("/admin/settings", payload);
      setSettings(data);
      toast.success("Parametres enregistres");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  const set = (key) => (e) => setSettings((current) => ({ ...current, [key]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));
  const statusBadge = (ok) => <Badge tone={ok ? "success" : "danger"}>{ok ? "OK" : "A faire"}</Badge>;

  return (
    <AdminShell title="Parametres">
      <div className="admin-page-header">
        <div className="min-w-0">
          <h1 className="responsive-title font-heading text-3xl font-black tracking-tighter sm:text-4xl">Parametres production</h1>
          <p className="text-sm text-muted-foreground">Tarifs, providers, securite, notifications et templates.</p>
        </div>
      </div>
      <div className="mt-5 grid gap-5 lg:grid-cols-2">
        <Card className="space-y-3 p-5">
          <h2 className="font-heading text-xl font-bold">Configuration modifiable</h2>
          {[
            ["app_name", "Nom app"],
            ["support_email", "Email support"],
            ["support_phone", "Telephone support"],
            ["platform_commission_rate", "Commission plateforme"],
            ["driver_match_max_km", "Rayon matching chauffeur km"],
            ["service_radius_km", "Rayon zone service km"],
          ].map(([key, label]) => (
            <div key={key}>
              <Label>{label}</Label>
              <Input value={settings[key] ?? ""} onChange={set(key)} />
            </div>
          ))}
          <label className="flex items-center justify-between gap-3 rounded-2xl bg-white/5 p-3 text-sm font-bold">
            <span>IA promo automatique avec approbation</span>
            <input type="checkbox" checked={Boolean(settings.promo_auto_ai_enabled)} onChange={set("promo_auto_ai_enabled")} />
          </label>
          <label className="flex items-center justify-between gap-3 rounded-2xl bg-white/5 p-3 text-sm font-bold">
            <span>Verification email obligatoire</span>
            <input type="checkbox" checked={Boolean(settings.require_email_verification)} onChange={set("require_email_verification")} />
          </label>
          <Button onClick={save} className="w-full">Enregistrer</Button>
        </Card>

        <Card className="space-y-3 p-5">
          <h2 className="font-heading text-xl font-bold">Securite & providers</h2>
          {security && Object.entries({
            "VAPID prive": security.vapid_private_configured,
            "VAPID public": security.vapid_public_configured,
            SMTP: security.smtp_configured,
            LiveKit: security.livekit_configured,
            "JWT secret change": security.jwt_secret_changed,
            "Cookies secure": security.cookie_secure,
            "DEBUG OTP desactive": !security.debug_otp,
          }).map(([label, ok]) => (
            <div key={label} className="flex items-center justify-between gap-3 rounded-2xl bg-white/5 p-3">
              <span className="min-w-0 text-sm font-bold">{label}</span>{statusBadge(ok)}
            </div>
          ))}
          <div className="rounded-2xl border border-warning/30 bg-warning/10 p-3 text-xs text-muted-foreground">
            Regenerer tous les secrets partages dans le chat avant production.
          </div>
        </Card>

        <Card className="space-y-3 p-5 lg:col-span-2">
          <h2 className="font-heading text-xl font-bold">Templates WhatsApp Meta a approuver</h2>
          <div className="text-xs text-muted-foreground">{whatsapp?.status}</div>
          <div className="grid gap-3 md:grid-cols-3">
            {(whatsapp?.templates || []).map((t) => (
              <div key={t.name} className="rounded-2xl bg-white/5 p-4">
                <Badge tone="primary">{t.category}</Badge>
                <div className="mt-2 font-mono text-xs font-bold">{t.name}</div>
                <div className="mt-2 text-xs text-muted-foreground">{t.body}</div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </AdminShell>
  );
}
